import { useState, useCallback, useMemo } from 'react';

const MIN = 10000;
const MAX = 99999;

export const FORBIDDEN_RTDB_KEY_CHARS = /[.$#[\]/\x00-\x1F\x7F]/;

const generateRandom = (exclude) => {
  let value = Math.floor(Math.random() * (MAX - MIN + 1)) + MIN;
  while (value === exclude) {
    value = Math.floor(Math.random() * (MAX - MIN + 1)) + MIN;
  }
  return value;
};

export const useRandomCode = (name) => {
  const [num1, setNum1] = useState(() => generateRandom());
  const [num2, setNum2] = useState(() => generateRandom());

  const cleanName = name.replace(new RegExp(FORBIDDEN_RTDB_KEY_CHARS, 'g'), '');

  const randomize = useCallback(() => {
    setNum1((prev) => generateRandom(prev));
    setNum2((prev) => generateRandom(prev));
  }, []);

  const setCode = (code) => {
    const firstNum = code.slice(-11, -6);
    const secondNum = code.slice(-5);
    setNum1(firstNum);
    setNum2(secondNum);
  };

  const code = useMemo(() => {
    return cleanName ? `${normalizeCode(cleanName)}-${num1}-${num2}` : '';
  }, [cleanName, num1, num2]);

  return { num1, num2, code, randomize, setCode };
};

const normalizeCode = (str) =>
  str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '')
    .replace(new RegExp(FORBIDDEN_RTDB_KEY_CHARS, 'g'), '')
    .toLowerCase();
